import React, {useEffect} from 'react';

import {withTryCatch} from 'coreUtils/reactUtils';

import {useCarouselContext} from 'brandComponents/Carousel/CarouselContext';

import {IModuleFactoryProps} from './IModuleFactory';
import {
	CarouselModule,
	CelebritiesWrapper,
	DiscoverMore,
	EditorialModule2,
	EditorialModule3,
	ImageCarousel,
	ImageVideoText,
	TopBannerV1,
	TopBannerV3,
} from './Subcomponents';

const modulesMap = {
	ImageVideoText,
	ImageCarousel,
	CarouselModule,
	ProductCarousel: CarouselModule,
	TopBannerV1,
	TopBannerV2: TopBannerV1,
	TopBannerV3,
	EditorialModule3,
	CelebritiesWrapper,
	EditorialModule2,
	DiscoverMore,
};

const ModuleFactory = (props: IModuleFactoryProps) => {
	const carouselContext = useCarouselContext(true);
	const currentVariant = props.variant;

	useEffect(() => {
		if (!carouselContext) {
			return;
		}

		carouselContext.registerCarouselClassName('swiper', `module-carousel ${currentVariant}-carousel`);

		return () => {
			carouselContext.unRegisterCarouselClassName('swiper', `module-carousel ${currentVariant}-carousel`);
		};
	}, []);

	// Check if the variant is valid
	if (!modulesMap[currentVariant]) {
		console.error(`🔥 Invalid module variant: ${currentVariant}`);

		return <></>;
	}

	const Module = withTryCatch(modulesMap[currentVariant]);

	return <Module {...props} />;
};

export default ModuleFactory;
